import * as React from 'react';

/**
 * Provides a portal container to all Radix primitives rendered inside a
 * `ShadcnScope`. Without this, Radix portals default to `document.body`,
 * which is outside the shadow DOM where Tailwind CSS isn't loaded — the
 * portaled content renders unstyled. With this context, portals target a
 * node inside the shadow root so Tailwind classes apply.
 *
 * Defaults to `null` when not inside a ShadcnScope, in which case Radix
 * falls back to its default behavior (document.body).
 */
const PortalContainerContext = React.createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

export const usePortalContainer = (): HTMLElement | null => React.useContext(PortalContainerContext);
